import Popper from 'popper.js/dist/umd/popper.js';
window.Popper = Popper;
import 'bootstrap';

jQuery(document).ready(function($){
    console.log('howdy');
});


// WEBPACK FOOTER //
// ./js/main.js